import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'TEACHER_LIST_GET_ALL',
  GET_ALL_SUCCESS: 'TEACHER_LIST_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TEACHER_LIST_GET_ALL_FAILURE',

  POST: 'TEACHER_POST',
  POST_SUCCESS: 'TEACHER_POST_SUCCESS',
  POST_FAILURE: 'TEACHER_POST_FAILURE',

  INVALIDATE_LIST: 'TEACHER_LIST_INVALIDATE_ALL',
};

export const getAll = actions.getAll(
  (query, meta) => `${BASE_URL}/teachers/?${stringify(meta)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post((id, value) => `${BASE_URL}/teachers/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const invalidateList = params => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_LIST,
    payload: { params },
  });
};
